// plugins/vuetify.ts

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components, // Zaregistruje všechny komponenty Vuetify
  directives, // Zaregistruje všechny direktivy Vuetify
  theme: {
    defaultTheme: 'light', // Nastavíme výchozí téma na světlé
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#FFFFFF', // Výchozí pozadí nastaveno na šedou
          primary: '#1976D2',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#E53935',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          brand: '#0966ff', // Definice barvy pro 0D47A1
          brandLight: '#b9d4ff', // Definice barvy pro 0D47A1
          accentcolor: '#f5c83f', // Definice barvy pro D32F2F
          iconcolor: "#999999",
          energycolor: "#1976D2",
          alertcolor: "#c8102e",
          firstLineColor: 'rgba(163,10,54,255)',
          secondLineColor: '#fb9124',
          thirdLineColor: '#74c476',
          description: '#666',
          modalBackground: 'rgb(37, 37, 37)',
          eventFree: '#005a32',
          eventFull: 'rgba(163,10,54,255)'
        },
      },
      customDarkTheme: {
        dark: true, // Definujeme, že se jedná o tmavé téma
        colors: {
          primary: '#1E88E5', // Definice primární barvy
          secondary: '#42A5F5', // Definice sekundární barvy
          accent: '#9C27B0', // Akcentní barva
          error: '#FF5252', // Barva pro chyby
          info: '#2196F3', // Barva pro informaci
          success: '#4CAF50', // Barva pro úspěch
          warning: '#FB8C00', // Barva pro varování
          background: '#121212', // Vlastní barva pozadí pro tmavé téma
          mhblue: 'rgba(35,45,70,255)', // Vlastní barva
          white: 'rgba(240,240,240,255)', // Vlastní barva
          mhred: 'rgba(163,10,54,255)', // Vlastní barva
          mhgold: '#BBA53D', // Vlastní barva
          listBackground: 'rgba(35,45,70,0.8)',
          firstLineColor: 'rgba(163,10,54,255)',
          secondLineColor: '#fb9124',
          thirdLineColor: '#74c476',
          gold: '#BBA53D',
        },
      },
    },
  },
})
